"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTitle = void 0;
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../../../helpers");
const layouts_1 = require("../../..");
const FormTitle_styles_1 = require("./FormTitle.styles");
const Text_1 = require("../../../../Text");
exports.FormTitle = (0, helpers_1.createUIElement)('FormTitle', (_a, ref) => {
    var { className, children, rightAddon, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: dataSelectorId } = _a, rest = __rest(_a, ["className", "children", "rightAddon", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    return (react_1.default.createElement(FormTitle_styles_1.StyledFormTitle, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": dataSelectorId, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-FormTitle', className) }),
        react_1.default.createElement("td", { colSpan: 2 }, rightAddon ? (react_1.default.createElement(FormTitle_styles_1.StyledFormTitleInnerWithRightAddon, null,
            react_1.default.createElement(Text_1.Text, { size: Text_1.TEXT_SIZE.m, weight: Text_1.TEXT_WEIGHT.semiBold, truncate: true },
                react_1.default.createElement("span", null, children)),
            react_1.default.createElement(layouts_1.Spacer, null),
            react_1.default.createElement(FormTitle_styles_1.StyledFormTitleRightAddonWrapper, null, rightAddon))) : (react_1.default.createElement(FormTitle_styles_1.StyledFormTitleInner, null,
            react_1.default.createElement(Text_1.Text, { size: Text_1.TEXT_SIZE.m, weight: Text_1.TEXT_WEIGHT.semiBold, truncate: true },
                react_1.default.createElement("span", null, children)))))));
});
//# sourceMappingURL=FormTitle.js.map